
import { async_command_dispatcher } from "@/api/client"

export class MassiveUpdateIsArchivedCommand {
    
    constructor() {}

    async run(company_ids: Array<number>, is_archived: boolean) {
        let args = {company_ids: company_ids, is_archived: is_archived}

        let resOutput
        try {
            resOutput = await async_command_dispatcher.dispatch_with_result('massive.update.companydb.is.archived', args, 1000)
        } catch (error) {
            console.error("Error updating 'is_archived':", error)
            resOutput = null
        }

        if (resOutput) return resOutput
        return null
    }
}